import { Element } from '../../../common/html/element'
import { HandleDetail } from '../../common/handleDetail'

const NumberCompanyCell = ({ val, rowId, isDynamicReport }) => {
  return (
    <Element className={'cursorPointer'}>
      <HandleDetail
        path="PortfolioInsights/Details"
        otherParams={{
          param: { locationId: Number(rowId) },
          isHighlight: false,
        }}
        style={{ color: isDynamicReport ? '#3A414B' : '#0553A5' }}
      >
        {val}
      </HandleDetail>
    </Element>
  )
}

export default NumberCompanyCell
